import { observable, action } from "mobx";

const Store = observable(
  {
    entities: null,
    query: "",
    advancedFilter: false,
    page: 0,
    searchValues: {
      with_debts: false,
      no_requests: false,
    },
    setPage(page) {
      this.page = page;
    },
    setQuery(query) {
      this.query = query;
    },
    setSearchValues(vals) {
      this.searchValues = vals;
    },
    setCount(count) {
      this.count = count;
    },
    toggleAdvancedFilter() {
      this.advancedFilter = !this.advancedFilter;
    },
    setEntities(entities) {
      this.entities = entities;
    },
  },
  {
    setPage: action,
    setQuery: action,
    setCount: action,
    setSearchValues: action,
    setEntities: action,
  }
);

export default Store;
